import "../../../App.css";
import "./AccountStatement.css";

import {
    useCallback,
    useEffect,
    useMemo,
    useState,
} from "react";
import {
    Input,
    Select,
    Table,
    notification,
} from "antd";
import axios from "axios";
import moment from "moment";

import Appconfig from "../../../config/config";

const ACCOUNT_TYPES = {
    ALL: "All",
    DEPOSIT_WITHDRAW:
        "Deposit/Withdraw Report",
    SPORTS: "Sports Report",
    CASINO: "Casino Report",
    THIRD_PARTY:
        "Third Party Casino Report",
};

const ACCOUNT_TYPE_OPTIONS = [
    {
        label: "All",
        value: ACCOUNT_TYPES.ALL,
    },
    {
        label: "Deposit/Withdraw Report",
        value:
            ACCOUNT_TYPES.DEPOSIT_WITHDRAW,
    },
    {
        label: "Sports Report",
        value: ACCOUNT_TYPES.SPORTS,
    },
    {
        label: "Casino Report",
        value: ACCOUNT_TYPES.CASINO,
    },
    {
        label: "Third Party Casino Report",
        value: ACCOUNT_TYPES.THIRD_PARTY,
    },
];

const DEPOSIT_GAME_OPTIONS = [
    {
        label: "All",
        value: "All",
    },
    {
        label: "Upper",
        value: "Upper",
    },
    {
        label: "Down",
        value: "Down",
    },
];

const SPORTS_OPTIONS = [
    { label: "All", value: "All" },
    { label: "Football", value: "Football" },
    { label: "Tennis", value: "Tennis" },
    {
        label: "Mixed Martial Arts",
        value: "Mixed Martial Arts",
    },
    { label: "Cricket", value: "Cricket" },
    { label: "Golf", value: "Golf" },
    { label: "Boxing", value: "Boxing" },
    {
        label: "Beach Volleyball",
        value: "Beach Volleyball",
    },
    {
        label: "Table Tennis",
        value: "Table Tennis",
    },
    { label: "Futsal", value: "Futsal" },
    {
        label: "Horse Racing",
        value: "Horse Racing",
    },
    { label: "E Games", value: "E Games" },
    {
        label: "Basketball",
        value: "Basketball",
    },
    { label: "MotoGP", value: "MotoGP" },
    { label: "Chess", value: "Chess" },
    {
        label: "Volleyball",
        value: "Volleyball",
    },
    {
        label: "Ice Hockey",
        value: "Ice Hockey",
    },
    {
        label: "Badminton",
        value: "Badminton",
    },
    { label: "Hockey", value: "Hockey" },
    { label: "Cycling", value: "Cycling" },
    {
        label: "Motorbikes",
        value: "Motorbikes",
    },
    {
        label: "Athletics",
        value: "Athletics",
    },
    {
        label: "Basketball 3X3",
        value: "Basketball 3X3",
    },
    { label: "Sumo", value: "Sumo" },
    {
        label: "Virtual sports",
        value: "Virtual sports",
    },
    {
        label: "Handball",
        value: "Handball",
    },
];

const SPORTS_GAME_TYPE_OPTIONS = [
    { label: "All", value: "All" },
    { label: "Match", value: "Match" },
    { label: "Match1", value: "Match1" },
    { label: "Fancy", value: "Fancy" },
    { label: "Fancy1", value: "Fancy1" },
    { label: "Meter", value: "Meter" },
    { label: "Khado", value: "Khado" },
    { label: "oddeven", value: "oddeven" },
    {
        label: "cricket casino",
        value: "cricket casino",
    },
    {
        label: "U/O Line",
        value: "U/O Line",
    },
];

const CASINO_OPTIONS = [
    { label: "All", value: "All" },
    {
        label: "Teenpatti 1-day",
        value: "Teenpatti 1-day",
    },
    {
        label: "Poker 1-Day",
        value: "Poker 1-Day",
    },
    {
        label: "3 Cards Judgement",
        value: "3 Cards Judgement",
    },
    {
        label: "Amar Akbar Anthony",
        value: "Amar Akbar Anthony",
    },
    {
        label: "Andar Bahar",
        value: "Andar Bahar",
    },
    {
        label: "Andar Bahar 2",
        value: "Andar Bahar 2",
    },
    {
        label: "Baccarat",
        value: "Baccarat",
    },
    {
        label: "Baccarat 2",
        value: "Baccarat 2",
    },
    {
        label: "Bollywood Casino",
        value: "Bollywood Casino",
    },
    {
        label: "32 Cards A",
        value: "32 Cards A",
    },
    {
        label: "32 Cards B",
        value: "32 Cards B",
    },
    {
        label: "Cricket Match 20-20",
        value: "Cricket Match 20-20",
    },
    {
        label: "Casino Meter",
        value: "Casino Meter",
    },
    {
        label: "20-20 Dragon Tiger",
        value: "20-20 Dragon Tiger",
    },
    {
        label: "20-20 Dragon Tiger 2",
        value: "20-20 Dragon Tiger 2",
    },
    {
        label: "1 Day Dragon Tiger",
        value: "1 Day Dragon Tiger",
    },
    {
        label: "20-20 D T L",
        value: "20-20 D T L",
    },
    {
        label: "lottcard",
        value: "lottcard",
    },
    {
        label: "Lucky 7 - A",
        value: "Lucky 7 - A",
    },
];

const getLoggedInUser = () => {
    try {
        const storedUser =
            localStorage.getItem("userdata");

        return storedUser
            ? JSON.parse(storedUser)
            : {};
    } catch (error) {
        console.error(
            "Unable to read logged-in user:",
            error
        );

        return {};
    }
};

function AccountStatement() {
    const userInfo = getLoggedInUser();

    const [formData, setFormData] =
        useState({
            user_id: userInfo?._id || "",

            account_type:
                ACCOUNT_TYPES.ALL,

            game_name: "All",
            sports_list: "All",
            game_type: "All",
            casino_list: "All",

            client_name: "",

            from_date:
                moment().format("YYYY-MM-DD"),

            to_date:
                moment().format("YYYY-MM-DD"),
        });

    const [statementData, setStatementData] =
        useState([]);

    const [tableSearch, setTableSearch] =
        useState("");

    const [currentPage, setCurrentPage] =
        useState(1);

    const [pageSize] = useState(10);
    const [loading, setLoading] =
        useState(false);

    const updateFilter = (name, value) => {
        setFormData((previous) => ({
            ...previous,
            [name]: value,
        }));
    };

    const handleAccountTypeChange = (
        accountType
    ) => {
        setFormData((previous) => ({
            ...previous,

            account_type: accountType,

            // Reset all dependent dropdowns
            game_name: "All",
            sports_list: "All",
            game_type: "All",
            casino_list: "All",
        }));

        setCurrentPage(1);
    };

    const loadAccountStatement =
        useCallback(async () => {
            if (!formData.user_id) {
                notification.error({
                    message:
                        "Unable to Load Statement",
                    description:
                        "The logged-in user ID is missing.",
                });

                return;
            }

            if (
                moment(formData.from_date).isAfter(
                    moment(formData.to_date)
                )
            ) {
                notification.error({
                    message: "Invalid Date Range",
                    description:
                        "The From date cannot be later than the To date.",
                });

                return;
            }

            if (
                moment(formData.from_date).isAfter(
                    moment(formData.to_date)
                )
            ) {
                notification.error({
                    message: "Invalid Date Range",
                    description:
                        "The From date cannot be later than the To date.",
                });

                return;
            }

            const requestPayload = {
                user_id: formData.user_id,

                type: formData.account_type,

                game_name:
                    formData.game_name || "All",

                sports_list:
                    formData.sports_list || "All",

                game_type:
                    formData.game_type || "All",

                casino_list:
                    formData.casino_list || "All",

                client_name:
                    formData.client_name?.trim() ||
                    "",

                from_date: formData.from_date,
                to_date: formData.to_date,
            };

            setLoading(true);

            try {
                const response = await axios.post(
                    `${Appconfig.apiUrl}reports/aurafilteraccountStatement`,
                    requestPayload,
                    {
                        headers: {
                            "Content-Type":
                                "application/json",
                        },
                    }
                );

                const result =
                    response?.data?.resultData;

                setStatementData(
                    Array.isArray(result)
                        ? result
                        : []
                );

                setCurrentPage(1);
            } catch (error) {
                console.error(
                    "Account statement error:",
                    error
                );

                notification.error({
                    message:
                        "Unable to Load Statement",
                    description:
                        error?.response?.data
                            ?.message ||
                        error?.message ||
                        "The account statement could not be loaded.",
                });

                setStatementData([]);
            } finally {
                setLoading(false);
            }
        }, [formData]);

    useEffect(() => {
        loadAccountStatement();
        // Initial request only
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const filteredData = useMemo(() => {
        const keyword = tableSearch
            .trim()
            .toLowerCase();

        if (!keyword) {
            return statementData;
        }

        return statementData.filter(
            (record) =>
                [
                    record?.createdAt,
                    record?.amount,
                    record?.balance,
                    record?.remarks,
                    record?.from,
                    record?.to,
                    record?.transaction_type,
                ].some((value) =>
                    String(value ?? "")
                        .toLowerCase()
                        .includes(keyword)
                )
        );
    }, [statementData, tableSearch]);

    const totalPages = Math.max(
        1,
        Math.ceil(
            filteredData.length / pageSize
        )
    );

    const safeCurrentPage = Math.min(
        currentPage,
        totalPages
    );

    const startIndex =
        (safeCurrentPage - 1) * pageSize;

    const endIndex = Math.min(
        startIndex + pageSize,
        filteredData.length
    );

    const paginatedData = filteredData.slice(
        startIndex,
        endIndex
    );

    const formatAmount = (value) => {
        const number = Number(value);

        return Number.isFinite(number)
            ? number.toFixed(2)
            : "0.00";
    };

    const columns = [
        {
            title: "Date",
            dataIndex: "createdAt",
            key: "createdAt",
            render: (value) =>
                value
                    ? moment(value).format(
                        "DD/MM/YYYY HH:mm:ss"
                    )
                    : "-",
        },
        {
            title: "Credit",
            key: "credit",
            align: "right",
            render: (_, record) =>
                record?.transaction_type ===
                    "Credit"
                    ? formatAmount(record?.amount)
                    : "",
        },
        {
            title: "Debit",
            key: "debit",
            align: "right",
            render: (_, record) =>
                record?.transaction_type ===
                    "Debit"
                    ? formatAmount(record?.amount)
                    : "",
        },
        {
            title: "Closing",
            dataIndex: "balance",
            key: "balance",
            align: "right",
            render: (value) =>
                formatAmount(value),
        },
        {
            title: "Description",
            dataIndex: "remarks",
            key: "remarks",
            render: (value) => (
                <span className="statement-description">
                    {value || "-"}
                </span>
            ),
        },
        {
            title: "From/To",
            key: "fromTo",
            render: (_, record) => (
                <span className="statement-from-to">
                    <span>
                        {record?.from || "-"}
                    </span>

                    <span aria-hidden="true">
                        ▶
                    </span>

                    <span>
                        {record?.to || "-"}
                    </span>
                </span>
            ),
        },
    ];

    const printStatement = () => {
        window.print();
    };

    const exportToExcel = () => {
        if (!filteredData.length) {
            notification.warning({
                message: "No Data to Export",
                description:
                    "Load account-statement data before exporting.",
            });

            return;
        }

        const escapeCell = (value) =>
            `"${String(value ?? "").replace(
                /"/g,
                '""'
            )}"`;

        const headers = [
            "Date",
            "Credit",
            "Debit",
            "Closing",
            "Description",
            "From",
            "To",
        ];

        const rows = filteredData.map(
            (record) => [
                record?.createdAt
                    ? moment(
                        record.createdAt
                    ).format(
                        "DD/MM/YYYY HH:mm:ss"
                    )
                    : "",
                record?.transaction_type ===
                    "Credit"
                    ? formatAmount(
                        record?.amount
                    )
                    : "",
                record?.transaction_type ===
                    "Debit"
                    ? formatAmount(
                        record?.amount
                    )
                    : "",
                formatAmount(record?.balance),
                record?.remarks || "",
                record?.from || "",
                record?.to || "",
            ]
        );

        const csv = [
            headers.map(escapeCell).join(","),
            ...rows.map((row) =>
                row.map(escapeCell).join(",")
            ),
        ].join("\r\n");

        const blob = new Blob([csv], {
            type: "text/csv;charset=utf-8;",
        });

        const url =
            URL.createObjectURL(blob);

        const link =
            document.createElement("a");

        link.href = url;
        link.download = `account-statement-${moment().format(
            "YYYY-MM-DD"
        )}.csv`;

        document.body.appendChild(link);
        link.click();
        link.remove();

        URL.revokeObjectURL(url);
    };

    return (
        <section className="reference-statement">
            <h1 className="reference-statement-title">
                Account Statement
            </h1>

            <div
                className={`statement-filter-grid ${formData.account_type ===
                    ACCOUNT_TYPES.SPORTS
                    ? "sports-report-filters"
                    : ""
                    }`}
            >
                {/* Account Type */}
                <label className="statement-field">
                    <span>Account Type</span>

                    <Select
                        value={
                            formData.account_type
                        }
                        onChange={
                            handleAccountTypeChange
                        }
                        options={
                            ACCOUNT_TYPE_OPTIONS
                        }
                        popupClassName="statement-select-popup"
                    />
                </label>

                {/* All Report */}
                {formData.account_type ===
                    ACCOUNT_TYPES.ALL && (
                        <label className="statement-field">
                            <span>Game Name</span>

                            <Select
                                value={
                                    formData.game_name
                                }
                                onChange={(value) =>
                                    updateFilter(
                                        "game_name",
                                        value
                                    )
                                }
                                options={[
                                    {
                                        label: "All",
                                        value: "All",
                                    },
                                ]}
                                popupClassName="statement-select-popup"
                            />
                        </label>
                    )}

                {/* Deposit/Withdraw Report */}
                {formData.account_type ===
                    ACCOUNT_TYPES
                        .DEPOSIT_WITHDRAW && (
                        <label className="statement-field">
                            <span>Game Name</span>

                            <Select
                                value={
                                    formData.game_name
                                }
                                onChange={(value) =>
                                    updateFilter(
                                        "game_name",
                                        value
                                    )
                                }
                                options={
                                    DEPOSIT_GAME_OPTIONS
                                }
                                popupClassName="statement-select-popup"
                            />
                        </label>
                    )}

                {/* Sports Report */}
                {formData.account_type ===
                    ACCOUNT_TYPES.SPORTS && (
                        <>
                            <label className="statement-field">
                                <span>Sports List</span>

                                <Select
                                    showSearch
                                    value={
                                        formData.sports_list
                                    }
                                    onChange={(value) =>
                                        updateFilter(
                                            "sports_list",
                                            value
                                        )
                                    }
                                    options={
                                        SPORTS_OPTIONS
                                    }
                                    optionFilterProp="label"
                                    popupClassName="statement-select-popup statement-long-popup"
                                    listHeight={650}
                                />
                            </label>

                            <label className="statement-field">
                                <span>Game Type</span>

                                <Select
                                    value={
                                        formData.game_type
                                    }
                                    onChange={(value) =>
                                        updateFilter(
                                            "game_type",
                                            value
                                        )
                                    }
                                    options={
                                        SPORTS_GAME_TYPE_OPTIONS
                                    }
                                    popupClassName="statement-select-popup"
                                />
                            </label>
                        </>
                    )}

                {/* Casino Report */}
                {formData.account_type ===
                    ACCOUNT_TYPES.CASINO && (
                        <label className="statement-field">
                            <span>Casino List</span>

                            <Select
                                showSearch
                                value={
                                    formData.casino_list
                                }
                                onChange={(value) =>
                                    updateFilter(
                                        "casino_list",
                                        value
                                    )
                                }
                                options={
                                    CASINO_OPTIONS
                                }
                                optionFilterProp="label"
                                popupClassName="statement-select-popup statement-long-popup"
                                listHeight={650}
                            />
                        </label>
                    )}

                {/* Client Name */}
                <label className="statement-field">
                    <span>
                        Search By Client Name
                    </span>

                    <Input
                        value={
                            formData.client_name
                        }
                        placeholder="Client name"
                        onChange={(event) =>
                            updateFilter(
                                "client_name",
                                event.target.value
                            )
                        }
                        onPressEnter={
                            loadAccountStatement
                        }
                    />
                </label>

                {/* From Date */}
                <label className="statement-field">
                    <span>From</span>

                    <Input
                        type="date"
                        value={
                            formData.from_date
                        }
                        max={formData.to_date}
                        onChange={(event) =>
                            updateFilter(
                                "from_date",
                                event.target.value
                            )
                        }
                    />
                </label>

                {/* To Date */}
                <label className="statement-field">
                    <span>To</span>

                    <Input
                        type="date"
                        value={formData.to_date}
                        min={formData.from_date}
                        onChange={(event) =>
                            updateFilter(
                                "to_date",
                                event.target.value
                            )
                        }
                    />
                </label>
            </div>

            <button
                type="button"
                className="statement-load-button"
                disabled={loading}
                onClick={loadAccountStatement}
            >
                {loading ? "Loading..." : "Load"}
            </button>

            <div className="statement-toolbar">
                <div className="statement-export-buttons">
                    <button
                        type="button"
                        className="statement-pdf-button"
                        onClick={printStatement}
                    >
                        <i class="far fa-file-pdf mr-1"></i>
                        PDF
                    </button>

                    <button
                        type="button"
                        className="statement-excel-button"
                        onClick={exportToExcel}
                    >
                        <i class="far fa-file-excel mr-1"></i>
                        Excel
                    </button>
                </div>

                <label className="statement-table-search">
                    <span>Search:</span>

                    <Input
                        value={tableSearch}
                        placeholder="Search..."
                        onChange={(event) => {
                            setTableSearch(
                                event.target.value
                            );

                            setCurrentPage(1);
                        }}
                    />
                </label>
            </div>

            <div className="statement-table-wrapper">
                <Table
                    rowKey={(record, index) =>
                        record?._id ||
                        `${record?.createdAt}-${index}`
                    }
                    columns={columns}
                    dataSource={paginatedData}
                    loading={loading}
                    pagination={false}
                    locale={{
                        emptyText:
                            "No account statement data found.",
                    }}
                    scroll={{
                        x: 900,
                    }}
                />
            </div>

            <div className="statement-pagination">
                <span className="statement-showing">
                    Showing{" "}
                    {filteredData.length
                        ? startIndex + 1
                        : 0}{" "}
                    to {endIndex} of{" "}
                    {filteredData.length} entries
                </span>

                <div className="statement-page-buttons">
                    <button
                        type="button"
                        disabled={
                            safeCurrentPage === 1
                        }
                        onClick={() =>
                            setCurrentPage(1)
                        }
                    >
                        «
                    </button>

                    <button
                        type="button"
                        disabled={
                            safeCurrentPage === 1
                        }
                        onClick={() =>
                            setCurrentPage(
                                Math.max(
                                    1,
                                    safeCurrentPage -
                                    1
                                )
                            )
                        }
                    >
                        ‹
                    </button>

                    <button
                        type="button"
                        className="active"
                    >
                        {safeCurrentPage}
                    </button>

                    <button
                        type="button"
                        disabled={
                            safeCurrentPage ===
                            totalPages
                        }
                        onClick={() =>
                            setCurrentPage(
                                Math.min(
                                    totalPages,
                                    safeCurrentPage +
                                    1
                                )
                            )
                        }
                    >
                        ›
                    </button>

                    <button
                        type="button"
                        disabled={
                            safeCurrentPage ===
                            totalPages
                        }
                        onClick={() =>
                            setCurrentPage(
                                totalPages
                            )
                        }
                    >
                        »
                    </button>
                </div>
            </div>
        </section>
    );
}

export default AccountStatement;